const doc = [({"ko":({"adminConstantHotelFacilityType":({"activities":"활동", "camping":"캠프", "hotel":"숙박 시설"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;